import styled from 'styled-components';
import {FiDownload} from 'react-icons/fi';
import {media} from '../lib/theme';

const ListWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: -${({theme}) => theme.spacing.small};
`;

const DownloadItem = styled.a`
  padding: ${({theme}) => theme.spacing.small};
  margin-bottom: ${({theme}) => theme.spacing.small};
  border: 2px solid ${({theme}) => theme.colors.green};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  width: 100%;
  ${media.sm`
    width: unset;
    margin-right: ${({theme}) => theme.spacing.small};
  `}
  cursor: pointer;
  & > svg {
    margin-right: ${({theme}) => theme.spacing.xsmall};
  }
  &:hover {
    color: ${({theme}) => theme.colors.white};
    background-color: ${({theme}) => theme.colors.green};
    text-decoration: none;
  }
`;

const DownloadList = ({items, onClick = () => {}}) => (
  <ListWrapper>
    {items?.map(({title, link}, index) => (
      <DownloadItem onClick={() => onClick({title, link})} href={link} target='_blank' key={index}>
        <FiDownload />
        {title}
      </DownloadItem>
    ))}
  </ListWrapper>
);

export default DownloadList;
